<template>
  <div
    class="w-full flex-y-center justify-between border-b border-gray-250 pb-3 last:pb-0 last:border-transparent"
  >
    <div class="flex items-center gap-2">
      <div
        class="p-2 !w-12 !h-12 rounded-full"
        :class="checkProfit(Number(totalProfit))?.color"
      >
        <svg
          :class="[
            checkProfit(Number(totalProfit))?.position,
            checkProfit(Number(totalProfit))?.textColor,
          ]"
          xmlns="http://www.w3.org/2000/svg"
          class="icon icon-tabler icon-tabler-trending-up !w-8 !h-8"
          width="44"
          height="44"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="#fff"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M3 17l6 -6l4 4l8 -8" />
          <path d="M14 7l7 0l0 7" />
        </svg>
      </div>
      <p class="text-dark-300 text-sm !leading-normal font-semibold">
        {{ title }}
      </p>
    </div>
    <div>
      <h5
        class="text-[15px] !leading-normal text-dark-300 font-semibold truncate"
      >
        {{ formatMoneyExact(totalProfit, 2) }} USDT
      </h5>
      <ProfitLostInfo :percentage="percentMean" :profit="totalProfit" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { checkProfit, formatMoneyExact } from "@/utils";
import ProfitLostInfo from "@/components/Common/ProfitLostInfo.vue";

interface Props {
  title?: string;
  totalProfit?: string;
  percentMean?: number;
}
defineProps<Props>();
</script>

<style scoped></style>
